module.exports = __webpack_public_path__ + "img/1_3_1.9f67086b.jpg";